import FlameIcon from '~/assets/icons/Flame';

type Props = {
  count: number;
};

function getShortenedCount(count: number) {
  return count >= 1000 ? `${(count / 1000).toFixed(1)}k` : count;
}

const ProductNotificationCount = ({ count }: Props) => {
  return (
    <>
      <div className="flex mt-2 w-full rounded-[80px] px-3 py-2 justify-center items-center gap-1 self-stretchrounded-[80px] border-[1px] bg-gradient-to-b from-purple-hola-light/[0.16] to-purple-hola-light[0.16] bg-white border-purple-hola">
        <FlameIcon width={16} height={16} />

        <p className="text-purple-hola text-xs font-normal lg:hidden text-nowrap">
          {getShortenedCount(count)} notifications set
        </p>
        <p className="text-purple-hola text-xs font-normal hidden lg:block text-nowrap">
          {getShortenedCount(count)} notifications set in the last 7 days
        </p>
      </div>
    </>
  );
};

export default ProductNotificationCount;
